// extracted by mini-css-extract-plugin
export var accentColor = "var(--color-accent)";
export var categoryBorderColor = "var(--color-border)";
export var disableRipple = "false";
export var fontFamily = "var(--font-family)";
export var mainColor = "#07a32b";
export var mainContrast = "#fff";
export var panelBorderColor = "var(--color-border)";
export var secondaryColor = "#f60";
export var secondaryContrast = "rgba(0,0,0,.87)";